module.exports = __webpack_public_path__ + "static/media/bg3-mobile.bf00933b.png";